import { render, staticRenderFns } from "./ema.vue?vue&type=template&id=4aa597dd&scoped=true"
import script from "./ema.vue?vue&type=script&lang=js"
export * from "./ema.vue?vue&type=script&lang=js"
import style0 from "./ema.vue?vue&type=style&index=0&id=4aa597dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa597dd",
  null
  
)

export default component.exports